import * as S from "./Charts.style";

interface ChartsProps {
  title?: string;
  status?: string;
  children?: React.ReactNode;
}

export const Charts = ({ title, status, children }: ChartsProps) => {
  return (
    <S.Charts>
      <S.ChartTit>
        <S.TitBox>{title}</S.TitBox>
        {status && <S.StatusBox $statusLabel={status}>{status}</S.StatusBox>}
      </S.ChartTit>
      {children}
    </S.Charts>
  );
};
